// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"04a25590c27cebaafff5","655":"baf5f4887a2b30cf41d4"}[chunkId] + ".js";
};